import { tva } from "@gluestack-ui/nativewind-utils";
import { MedicationFormEnum } from "app/services/api/types/medications/enums/MedicationFormEnum";
import { View } from "ui/atoms/view";
import { Icon } from "ui/gluestack/icon";
import { CapsuleIcon } from "ui/gluestack/icon/CapsuleIcon";
import { DropIcon } from "ui/gluestack/icon/DropIcon";
import { InjectionIcon } from "ui/gluestack/icon/InjectionIcon";
import { LiquidIcon } from "ui/gluestack/icon/LiquidIcon";
import { OtherIcon } from "ui/gluestack/icon/OtherIcon";
import { PacketIcon } from "ui/gluestack/icon/PacketIcon";
import { PatchIcon } from "ui/gluestack/icon/PatchIcon";
import { SuppositoryIcon } from "ui/gluestack/icon/SuppositoryIcon";
import { TabletIcon } from "ui/gluestack/icon/TabletIcon";
import { UnspecifiedFormIcon } from "ui/gluestack/icon/UnspecifiedFormIcon";

interface Props {
  type: MedicationFormEnum;
}

const IconMapping = {
  [MedicationFormEnum.TABLET]: TabletIcon,
  [MedicationFormEnum.LIQUID]: LiquidIcon,
  [MedicationFormEnum.CAPSULE]: CapsuleIcon,
  [MedicationFormEnum.DROP]: DropIcon,
  [MedicationFormEnum.PACKET]: PacketIcon,
  [MedicationFormEnum.PATCH]: PatchIcon,
  [MedicationFormEnum.SUPPOSITORY]: SuppositoryIcon,
  [MedicationFormEnum.UNSPECIFIED]: UnspecifiedFormIcon,
  [MedicationFormEnum.INJECTION]: InjectionIcon,
  [MedicationFormEnum.OTHER]: OtherIcon,
};
export function MedicationFormIcon({ type }: Props) {
  const backgroundStyle = tva({
    base: "rounded-full w-16 h-16 items-center justify-center",
    parentVariants: {
      variant: {
        [MedicationFormEnum.TABLET]: "bg-[#FFF9DB]",
        [MedicationFormEnum.LIQUID]: "bg-[#D9F4FF]",
        [MedicationFormEnum.CAPSULE]: "bg-secondary-50",
        [MedicationFormEnum.DROP]: "bg-[#FFF1EC]",
        [MedicationFormEnum.PACKET]: "bg-[#FCFFD9]",
        [MedicationFormEnum.PATCH]: "bg-[#FBECFF]",
        [MedicationFormEnum.SUPPOSITORY]: "bg-[#D8FFFF]",
        [MedicationFormEnum.UNSPECIFIED]: "bg-[#FFECF2]",
        [MedicationFormEnum.INJECTION]: "bg-[#F1FAE6]",
        [MedicationFormEnum.OTHER]: "bg-[#FFF2EB]",
      } as Record<MedicationFormEnum, string>,
    },
  });

  const iconStyle = tva({
    base: "w-9 h-9",
    parentVariants: {
      variant: {
        [MedicationFormEnum.TABLET]: "text-[#856F00]",
        [MedicationFormEnum.LIQUID]: "text-[#003B53]",
        [MedicationFormEnum.CAPSULE]: "fill-secondary-950",
        [MedicationFormEnum.DROP]: "text-[#EF672C]",
        [MedicationFormEnum.PACKET]: "text-[#737D00]",
        [MedicationFormEnum.PATCH]: "text-[#A000CB] w-6 h-6",
        [MedicationFormEnum.SUPPOSITORY]: "text-[#005A5A]",
        [MedicationFormEnum.UNSPECIFIED]: "text-[#D50043] w-6 h-6",
        [MedicationFormEnum.INJECTION]: "fill-[#559A00]",
        [MedicationFormEnum.OTHER]: "text-tertiary-800 w-6 h-6",
      } as Record<MedicationFormEnum, string>,
    },
  });

  return (
    <View className={backgroundStyle({ variant: type })}>
      <Icon
        as={IconMapping[type] ?? IconMapping[MedicationFormEnum.OTHER]}
        className={iconStyle({ variant: type })}
      />
    </View>
  );
}
